import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dashIfNotDefined',
})
export class DashIfNotDefinedPipe implements PipeTransform {
  transform(value: any): any {
    if (value === null || value === undefined) {
      return '-';
    }

    return value;
  }
}
